import { render, staticRenderFns } from "./CustomerPreferenceAction.vue?vue&type=template&id=24d7c93c&scoped=true"
import script from "./CustomerPreferenceAction.vue?vue&type=script&lang=js"
export * from "./CustomerPreferenceAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d7c93c",
  null
  
)

export default component.exports